import { FormControlLabel, Switch } from "@mui/material";
import { useListContext } from "react-admin";

export const SoftDeleteToggle = () => {
	const { filterValues, setFilters, displayedFilters } = useListContext();

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFilters(
			{
				...filterValues,
				includeDeleted: event.target.checked,
			},
			displayedFilters,
		);
	};

	return (
		<FormControlLabel
			control={
				<Switch
					checked={filterValues.includeDeleted || false}
					onChange={handleChange}
					size="small"
				/>
			}
			label="Show deleted"
			sx={{ ml: 2 }}
		/>
	);
};
